import styled from 'styled-components';
import { spin } from '../../../../utils/style';
import { BaseStyledComponentProps } from '../../../../utils/styles-constants';
import { ParametersPageButton } from '../../../ParametersPage/styles';

interface StyledUpdateFolderTreeButton {
	isUpdating?: boolean;
}
const StyledUpdateFolderTreeButton = styled(ParametersPageButton)`
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.strongColor}

	& > svg {
		position: relative;
		left: 5px;
		height: 25px;
		width: 25px;
		animation: ${spin};
	}

	${ (p: StyledUpdateFolderTreeButton) => p.isUpdating && `
	& > span {
		margin-left: 15px;
	}`}
`;

export { StyledUpdateFolderTreeButton };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/ActionButtons/UpdateFolderTreeButton/styles.ts